module.exports = __webpack_public_path__ + "static/img/about.0e57ccfe.png";